import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import ShimmerEffect from "../ShimmerEffects/ListingShimmer/index";

function CustomDropdown({
  options,
  selectedValue,
  onChange,
  className,
  inputLabel,
  onDropdownOpen,
  loader,
}) {
  // Handle case when options might be empty or selectedValue is undefined
  const defaultSelectedValue =
    selectedValue || (options.length > 0 ? options[0].value : "");

  const handleOpen = () => {
    if (onDropdownOpen) {
      onDropdownOpen(); // trigger any necessary function when the dropdown opens
    }
  };

  const handleChange = (e) => {
    // Find the option object that matches the selected value
    const selectedOption = options.find(
      (option) => option.value === e.target.value
    );

    // Pass the whole object to the onChange callback
    if (selectedOption) {
      onChange(selectedOption);
    }
  };

  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="dropdown-label">{inputLabel}</InputLabel>
      <Select
        labelId="dropdown-label"
        value={defaultSelectedValue}
        onChange={handleChange}
        label={inputLabel}
        onOpen={handleOpen}
        defaultValue={defaultSelectedValue}
      >
        {loader ? (
          <div>
            <ShimmerEffect totalShimmerElement={6} />
          </div>
        ) : (
          options.map((option) => (
            <MenuItem key={option.id} value={option.value}>
              {option.label}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
}

export default CustomDropdown;
